import type { DashboardChildNavItem } from "./types";

export interface ChildDashboardSectionGroup {
  name: string;
  dashboards: DashboardChildNavItem[];
}

export function groupChildDashboardsBySection(
  children: DashboardChildNavItem[] | undefined,
  parentSection?: string | null,
): ChildDashboardSectionGroup[] {
  if (!children?.length) {
    return [];
  }

  const fallback = parentSection?.trim() || "Other";
  const map = new Map<string, DashboardChildNavItem[]>();

  for (const child of children) {
    const key = child.section?.trim() || fallback;
    const bucket = map.get(key);
    if (bucket) {
      bucket.push(child);
    } else {
      map.set(key, [child]);
    }
  }

  return Array.from(map.entries())
    .map(([name, dashboards]) => ({
      name,
      dashboards: [...dashboards].sort((a, b) =>
        a.title.localeCompare(b.title, undefined, { sensitivity: "base" }),
      ),
    }))
    .sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
    );
}
